var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-success btn-block",on:{"click":function($event){return _vm.$emit('click')}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Thêm\n  "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }